import { Dispatch } from 'redux';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import { NETWORK_ERROR_MODAL_TITLE } from '@mm/constants/error-descriptions';
import CrudActionContainer from '../actions/CrudActionContainer';
import somethingWentWrong from 'assets/something-went-wrong.png';

export type ResponseOrError = Response | TypeError | Error;

export const integrationsHandler =
  (dispatch: Dispatch<StoreState>, container: CrudActionContainer) =>
  (errorText?: string) => {
    dispatch(container.unbusy());
    dispatch(
      modalActions.openPrettyErrorModal({
        title: NETWORK_ERROR_MODAL_TITLE,
        detailsForNerds: errorText,
        contactSupport: true,
        image: somethingWentWrong,
      }),
    );

    return { error: true, errorText };
  };
